module.exports = __webpack_public_path__ + "img/spartan-sheetrock-framing-texture-03-med.f4b33a1b.jpg";